/**
 * @generated SignedSource<<75dc67bed6c2efce761cd8d41d39e8c1>>
 * @relayHash 509c79ed3aa65395a6739ffb9126f832
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceCommentLevel = "REPLY" | "TOP_LEVEL" | "%future added value";
export type ConfluenceInlineCommentStepType = "ADD_MARK" | "ADD_NODE_MARK" | "REMOVE_MARK" | "REMOVE_NODE_MARK" | "SET_ATTRS" | "%future added value";
export type ConfluenceSchedulePublishedType = "PUBLISHED" | "SCHEDULED" | "UNSCHEDULED" | "%future added value";
export type ConfluenceSubscriptionContentType = "BLOGPOST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluenceWorkflowApplicationChangeType = "CREATED" | "REMOVED" | "UPDATED" | "%future added value";
export type SubscriptionsContextProviderSubscription$variables = {
  id: string;
};
export type SubscriptionsContextProviderSubscription$data = {
  readonly confluence_onContentModified: {
    readonly __typename: "ConfluenceContentModified";
    readonly _deltas: ReadonlyArray<string> | null;
    readonly accountId: string | null;
    readonly commentCreated: {
      readonly __typename: "ConfluenceCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly pageCommentType: ConfluenceCommentLevel | null;
    } | null;
    readonly commentDeleted: {
      readonly __typename: "ConfluenceCommentUpdated";
      readonly commentId: string | null;
    } | null;
    readonly commentReopened: {
      readonly __typename: "ConfluenceCommentUpdated";
      readonly commentId: string | null;
    } | null;
    readonly commentResolved: {
      readonly __typename: "ConfluenceCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly pageCommentType: ConfluenceCommentLevel | null;
      readonly replies: ReadonlyArray<string> | null;
    } | null;
    readonly commentUpdated: {
      readonly __typename: "ConfluenceCommentUpdated";
      readonly commentId: string | null;
    } | null;
    readonly contentAccessDecisionMade: {
      readonly __typename: "ConfluenceContentAccessDecisionMade";
      readonly contentId: string | null;
      readonly decision: string | null;
    } | null;
    readonly contentAccessRequested: {
      readonly __typename: "ConfluenceContentAccessRequested";
      readonly contentId: string | null;
    } | null;
    readonly contentRestrictionUpdated: {
      readonly __typename: "ConfluenceContentRestrictionUpdated";
      readonly contentId: string | null;
    } | null;
    readonly contentStateDeleted: {
      readonly __typename: "ConfluenceContentPropertyDeleted";
      readonly key: string | null;
    } | null;
    readonly contentStateUpdated: {
      readonly __typename: "ConfluenceContentPropertyUpdated";
      readonly key: string | null;
      readonly value: string | null;
      readonly version: number | null;
    } | null;
    readonly contentUpdatedWithTemplate: {
      readonly __typename: "ConfluenceContentUpdatedWithTemplate";
      readonly spaceKey: string | null;
      readonly subtype: string | null;
    } | null;
    readonly coverPictureDeleted: {
      readonly __typename: "ConfluenceContentPropertyDeleted";
      readonly key: string | null;
    } | null;
    readonly coverPictureUpdated: {
      readonly __typename: "ConfluenceContentPropertyUpdated";
      readonly key: string | null;
      readonly value: string | null;
      readonly version: number | null;
    } | null;
    readonly coverPictureWidthUpdated: {
      readonly __typename: "ConfluenceCoverPictureWidthUpdated";
      readonly coverPictureWidth: string | null;
    } | null;
    readonly editorInlineCommentCreated: {
      readonly __typename: "ConfluenceInlineCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly inlineCommentType: ConfluenceCommentLevel | null;
      readonly markerRef: string | null;
    } | null;
    readonly embedUpdated: {
      readonly __typename: "ConfluenceEmbedUpdated";
      readonly isBlankStateUpdate: boolean | null;
      readonly product: string | null;
    } | null;
    readonly emojiTitleDeleted: {
      readonly __typename: "ConfluenceContentPropertyDeleted";
      readonly key: string | null;
    } | null;
    readonly emojiTitleUpdated: {
      readonly __typename: "ConfluenceContentPropertyUpdated";
      readonly key: string | null;
      readonly value: string | null;
      readonly version: number | null;
    } | null;
    readonly id: string;
    readonly inlineCommentCreated: {
      readonly __typename: "ConfluenceInlineCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly inlineCommentType: ConfluenceCommentLevel | null;
      readonly markerRef: string | null;
    } | null;
    readonly inlineCommentDeleted: {
      readonly __typename: "ConfluenceInlineCommentDeleted";
      readonly commentId: string | null;
      readonly inlineCommentType: ConfluenceCommentLevel | null;
      readonly markerRef: string | null;
    } | null;
    readonly inlineCommentReattached: {
      readonly __typename: "ConfluenceInlineCommentReattached";
      readonly commentId: string | null;
      readonly markerRef: string | null;
      readonly publishVersionNumber: number | null;
      readonly step: {
        readonly __typename: "ConfluenceInlineCommentStep";
        readonly from: number | null;
        readonly mark: {
          readonly __typename: "ConfluenceInlineCommentStepMark";
          readonly attrs: {
            readonly __typename: "ConfluenceInlineCommentStepMarkAttrs";
            readonly annotationType: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly inlineCommentResolved: {
      readonly __typename: "ConfluenceInlineCommentResolved";
      readonly commentId: string | null;
      readonly inlineResolveProperties: {
        readonly __typename: "ConfluenceInlineCommentResolveProperties";
        readonly isDangling: boolean | null;
        readonly resolved: boolean | null;
        readonly resolvedByDangling: boolean | null;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: string | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly inlineText: string | null;
      readonly markerRef: string | null;
      readonly replies: ReadonlyArray<string> | null;
    } | null;
    readonly inlineCommentUnresolved: {
      readonly __typename: "ConfluenceInlineCommentUpdated";
      readonly commentId: string | null;
      readonly markerRef: string | null;
    } | null;
    readonly inlineCommentUpdated: {
      readonly __typename: "ConfluenceInlineCommentUpdated";
      readonly commentId: string | null;
      readonly markerRef: string | null;
    } | null;
    readonly inlineReactionAdded: {
      readonly __typename: "ConfluenceInlineReactionAdded";
      readonly commentId: string | null;
      readonly emojiId: string | null;
      readonly markerRef: string | null;
      readonly newHighlight: boolean | null;
      readonly publishVersionNumber: number | null;
      readonly step: {
        readonly from: number | null;
        readonly mark: {
          readonly attrs: {
            readonly annotationType: string | null;
            readonly id: string | null;
          } | null;
          readonly type: string | null;
        } | null;
        readonly pos: number | null;
        readonly stepType: ConfluenceInlineCommentStepType | null;
        readonly to: number | null;
      } | null;
    } | null;
    readonly inlineReactionHighlightDeleted: {
      readonly __typename: "ConfluenceInlineReactionHighlightDeleted";
      readonly commentId: string | null;
      readonly markerRef: string | null;
    } | null;
    readonly inlineReactionRemoved: {
      readonly __typename: "ConfluenceInlineReactionRemoved";
      readonly commentId: string | null;
      readonly emojiId: string | null;
      readonly markerRef: string | null;
    } | null;
    readonly markdownModeUpdated: {
      readonly __typename: "ConfluenceMarkdownModeUpdated";
      readonly isMarkdownMode: boolean | null;
    } | null;
    readonly originTabId: string | null;
    readonly pageBlogified: {
      readonly __typename: "ConfluencePageBlogified";
      readonly blogTitle: string | null;
      readonly converterDisplayName: string | null;
      readonly spaceKey: string | null;
      readonly spaceName: string | null;
    } | null;
    readonly pageMigrated: {
      readonly __typename: "ConfluencePageMigrated";
      readonly fabricEligibility: string | null;
    } | null;
    readonly pageMoved: {
      readonly __typename: "ConfluencePageMoved";
      readonly newSpaceAlias: string | null;
      readonly newSpaceKey: string | null;
      readonly oldParentId: string | null;
      readonly oldPosition: number | null;
      readonly oldSpaceAlias: string | null;
      readonly oldSpaceKey: string | null;
    } | null;
    readonly pageTitlePropertyUpdated: {
      readonly __typename: "ConfluenceContentPropertyUpdated";
      readonly key: string | null;
      readonly value: string | null;
      readonly version: number | null;
    } | null;
    readonly pageUpdated: {
      readonly __typename: "ConfluencePageUpdated";
      readonly confVersion: number | null;
      readonly trigger: string | null;
    } | null;
    readonly rendererInlineCommentCreated: {
      readonly __typename: "ConfluenceRendererInlineCommentCreated";
      readonly adfBodyContent: string | null;
      readonly commentId: string | null;
      readonly inlineCommentType: ConfluenceCommentLevel | null;
      readonly markerRef: string | null;
      readonly publishVersionNumber: number | null;
      readonly step: {
        readonly __typename: "ConfluenceInlineCommentStep";
        readonly from: number | null;
        readonly mark: {
          readonly __typename: "ConfluenceInlineCommentStepMark";
          readonly attrs: {
            readonly __typename: "ConfluenceInlineCommentStepMarkAttrs";
            readonly annotationType: string | null;
          } | null;
        } | null;
        readonly pos: number | null;
        readonly to: number | null;
      } | null;
    } | null;
    readonly schedulePublished: {
      readonly __typename: "ConfluenceSchedulePublished";
      readonly confVersion: number | null;
      readonly eventType: ConfluenceSchedulePublishedType | null;
      readonly publishTime: string | null;
    } | null;
    readonly type: ConfluenceSubscriptionContentType;
    readonly workflowApplicationChanged: {
      readonly __typename: "ConfluenceWorkflowApplicationChanged";
      readonly changeType: ConfluenceWorkflowApplicationChangeType | null;
      readonly contentId: string | null;
      readonly contentStatus: string | null;
      readonly newWorkflowStatusId: string | null;
      readonly version: number | null;
    } | null;
  } | null;
};
export type SubscriptionsContextProviderSubscription = {
  response: SubscriptionsContextProviderSubscription$data;
  variables: SubscriptionsContextProviderSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "type"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = {
  "kind": "ScalarField",
  "name": "version"
},
v6 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "value"
  },
  (v5/*: any*/),
  (v3/*: any*/)
],
v7 = [
  (v4/*: any*/),
  (v3/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "spaceKey"
},
v9 = {
  "kind": "ScalarField",
  "name": "contentId"
},
v10 = [
  (v9/*: any*/),
  (v3/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "confVersion"
},
v12 = {
  "kind": "ScalarField",
  "name": "commentId"
},
v13 = {
  "kind": "ScalarField",
  "name": "inlineCommentType"
},
v14 = {
  "kind": "ScalarField",
  "name": "adfBodyContent"
},
v15 = {
  "kind": "ScalarField",
  "name": "markerRef"
},
v16 = {
  "kind": "ScalarField",
  "name": "publishVersionNumber"
},
v17 = {
  "kind": "ScalarField",
  "name": "from"
},
v18 = {
  "kind": "ScalarField",
  "name": "to"
},
v19 = {
  "kind": "ScalarField",
  "name": "pos"
},
v20 = {
  "kind": "ScalarField",
  "name": "annotationType"
},
v21 = [
  (v12/*: any*/),
  (v15/*: any*/),
  (v3/*: any*/)
],
v22 = {
  "kind": "ScalarField",
  "name": "replies"
},
v23 = {
  "kind": "ScalarField",
  "name": "pageCommentType"
},
v24 = [
  (v3/*: any*/),
  (v12/*: any*/)
],
v25 = {
  "kind": "ScalarField",
  "name": "emojiId"
},
v26 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ConfluenceContentModified",
    "kind": "LinkedField",
    "name": "confluence_onContentModified",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "accountId"
      },
      {
        "kind": "ScalarField",
        "name": "originTabId"
      },
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "_deltas"
      },
      {
        "concreteType": "ConfluenceContentPropertyUpdated",
        "kind": "LinkedField",
        "name": "contentStateUpdated",
        "plural": false,
        "selections": (v6/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyUpdated",
        "kind": "LinkedField",
        "name": "emojiTitleUpdated",
        "plural": false,
        "selections": (v6/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyUpdated",
        "kind": "LinkedField",
        "name": "coverPictureUpdated",
        "plural": false,
        "selections": (v6/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyUpdated",
        "kind": "LinkedField",
        "name": "pageTitlePropertyUpdated",
        "plural": false,
        "selections": (v6/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyDeleted",
        "kind": "LinkedField",
        "name": "coverPictureDeleted",
        "plural": false,
        "selections": (v7/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyDeleted",
        "kind": "LinkedField",
        "name": "emojiTitleDeleted",
        "plural": false,
        "selections": (v7/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentPropertyDeleted",
        "kind": "LinkedField",
        "name": "contentStateDeleted",
        "plural": false,
        "selections": (v7/*: any*/)
      },
      {
        "concreteType": "ConfluenceCoverPictureWidthUpdated",
        "kind": "LinkedField",
        "name": "coverPictureWidthUpdated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "coverPictureWidth"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluencePageBlogified",
        "kind": "LinkedField",
        "name": "pageBlogified",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "spaceName"
          },
          {
            "kind": "ScalarField",
            "name": "blogTitle"
          },
          {
            "kind": "ScalarField",
            "name": "converterDisplayName"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceEmbedUpdated",
        "kind": "LinkedField",
        "name": "embedUpdated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "product"
          },
          {
            "kind": "ScalarField",
            "name": "isBlankStateUpdate"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluencePageMigrated",
        "kind": "LinkedField",
        "name": "pageMigrated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "fabricEligibility"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceContentRestrictionUpdated",
        "kind": "LinkedField",
        "name": "contentRestrictionUpdated",
        "plural": false,
        "selections": (v10/*: any*/)
      },
      {
        "concreteType": "ConfluencePageMoved",
        "kind": "LinkedField",
        "name": "pageMoved",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "oldSpaceKey"
          },
          {
            "kind": "ScalarField",
            "name": "newSpaceKey"
          },
          {
            "kind": "ScalarField",
            "name": "oldParentId"
          },
          {
            "kind": "ScalarField",
            "name": "oldPosition"
          },
          {
            "kind": "ScalarField",
            "name": "newSpaceAlias"
          },
          {
            "kind": "ScalarField",
            "name": "oldSpaceAlias"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluencePageUpdated",
        "kind": "LinkedField",
        "name": "pageUpdated",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "trigger"
          },
          (v11/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceWorkflowApplicationChanged",
        "kind": "LinkedField",
        "name": "workflowApplicationChanged",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "name": "changeType"
          },
          {
            "kind": "ScalarField",
            "name": "newWorkflowStatusId"
          },
          {
            "kind": "ScalarField",
            "name": "contentStatus"
          },
          (v5/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceMarkdownModeUpdated",
        "kind": "LinkedField",
        "name": "markdownModeUpdated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isMarkdownMode"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceContentUpdatedWithTemplate",
        "kind": "LinkedField",
        "name": "contentUpdatedWithTemplate",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "subtype"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentCreated",
        "kind": "LinkedField",
        "name": "inlineCommentCreated",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v3/*: any*/),
          (v15/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceRendererInlineCommentCreated",
        "kind": "LinkedField",
        "name": "rendererInlineCommentCreated",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v12/*: any*/),
          (v14/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "ConfluenceInlineCommentStep",
            "kind": "LinkedField",
            "name": "step",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "ConfluenceInlineCommentStepMark",
                "kind": "LinkedField",
                "name": "mark",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                    "kind": "LinkedField",
                    "name": "attrs",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v3/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentCreated",
        "kind": "LinkedField",
        "name": "editorInlineCommentCreated",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentUpdated",
        "kind": "LinkedField",
        "name": "inlineCommentUpdated",
        "plural": false,
        "selections": (v21/*: any*/)
      },
      {
        "concreteType": "ConfluenceInlineCommentDeleted",
        "kind": "LinkedField",
        "name": "inlineCommentDeleted",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentResolved",
        "kind": "LinkedField",
        "name": "inlineCommentResolved",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "concreteType": "ConfluenceInlineCommentResolveProperties",
            "kind": "LinkedField",
            "name": "inlineResolveProperties",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isDangling"
              },
              {
                "kind": "ScalarField",
                "name": "resolved"
              },
              {
                "kind": "ScalarField",
                "name": "resolvedByDangling"
              },
              {
                "kind": "ScalarField",
                "name": "resolvedFriendlyDate"
              },
              {
                "kind": "ScalarField",
                "name": "resolvedTime"
              },
              {
                "kind": "ScalarField",
                "name": "resolvedUser"
              },
              (v3/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "inlineText"
          },
          (v15/*: any*/),
          (v22/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineCommentUpdated",
        "kind": "LinkedField",
        "name": "inlineCommentUnresolved",
        "plural": false,
        "selections": (v21/*: any*/)
      },
      {
        "concreteType": "ConfluenceInlineCommentReattached",
        "kind": "LinkedField",
        "name": "inlineCommentReattached",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v3/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "ConfluenceInlineCommentStep",
            "kind": "LinkedField",
            "name": "step",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "concreteType": "ConfluenceInlineCommentStepMark",
                "kind": "LinkedField",
                "name": "mark",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                    "kind": "LinkedField",
                    "name": "attrs",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v20/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "ConfluenceCommentCreated",
        "kind": "LinkedField",
        "name": "commentCreated",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v14/*: any*/),
          (v12/*: any*/),
          (v23/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceCommentUpdated",
        "kind": "LinkedField",
        "name": "commentUpdated",
        "plural": false,
        "selections": (v24/*: any*/)
      },
      {
        "concreteType": "ConfluenceCommentUpdated",
        "kind": "LinkedField",
        "name": "commentDeleted",
        "plural": false,
        "selections": (v24/*: any*/)
      },
      {
        "concreteType": "ConfluenceCommentCreated",
        "kind": "LinkedField",
        "name": "commentResolved",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v14/*: any*/),
          (v12/*: any*/),
          (v23/*: any*/),
          (v22/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceCommentUpdated",
        "kind": "LinkedField",
        "name": "commentReopened",
        "plural": false,
        "selections": (v24/*: any*/)
      },
      {
        "concreteType": "ConfluenceSchedulePublished",
        "kind": "LinkedField",
        "name": "schedulePublished",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "publishTime"
          },
          {
            "kind": "ScalarField",
            "name": "eventType"
          },
          (v11/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceContentAccessRequested",
        "kind": "LinkedField",
        "name": "contentAccessRequested",
        "plural": false,
        "selections": (v10/*: any*/)
      },
      {
        "concreteType": "ConfluenceContentAccessDecisionMade",
        "kind": "LinkedField",
        "name": "contentAccessDecisionMade",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "name": "decision"
          },
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineReactionAdded",
        "kind": "LinkedField",
        "name": "inlineReactionAdded",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v15/*: any*/),
          (v25/*: any*/),
          {
            "kind": "ScalarField",
            "name": "newHighlight"
          },
          {
            "concreteType": "ConfluenceInlineCommentStep",
            "kind": "LinkedField",
            "name": "step",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "ConfluenceInlineCommentStepMark",
                "kind": "LinkedField",
                "name": "mark",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                    "kind": "LinkedField",
                    "name": "attrs",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v2/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "stepType"
              }
            ]
          },
          (v16/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineReactionRemoved",
        "kind": "LinkedField",
        "name": "inlineReactionRemoved",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v15/*: any*/),
          (v25/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "concreteType": "ConfluenceInlineReactionHighlightDeleted",
        "kind": "LinkedField",
        "name": "inlineReactionHighlightDeleted",
        "plural": false,
        "selections": (v21/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SubscriptionsContextProviderSubscription",
    "selections": (v26/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionsContextProviderSubscription",
    "selections": (v26/*: any*/)
  },
  "params": {
    "cacheID": "509c79ed3aa65395a6739ffb9126f832",
    "id": "c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293",
    "metadata": {},
    "name": "SubscriptionsContextProviderSubscription",
    "operationKind": "subscription",
    "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,originTabId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},markdownModeUpdated{isMarkdownMode,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
  }
};
})();

(node as any).hash = "c37cfea9a825383fc3da89eb6b15ecfd";

export default node;
